const info = {
  ZH: { //中文翻译
    title: "\u7269\u8D28",
    type: "\u7C7B\u578B",
    name: "\u57FA\u672C\u7269\u8D28\u4E2D\u6587\u540D\u79F0",
    enname:"\u57FA\u672C\u7269\u8D28\u82F1\u6587\u540D\u79F0",
    aliasone: "\u522B\u540D1",
    aliastwo: "\u522B\u540D2",
    aliasthree: "\u522B\u540D3",
    cascode: "CAS\u7F16\u53F7",
    euIndex: "EU-Index",
    einecs: "EC\u7F16\u53F7",
    gadsl: "GADSL",
    confidential: "\u4FDD\u5BC6",
    reachSvhc: "REACH-SVHC",
    rate: "\u6BD4\u4F8B",
    yes: "\u662F",
    no: "\u5426",
    surplus: "\u5269\u4F59\u7684",
    fixed: "\u56FA\u5B9A\u7684",
    from: "\u4ECE",
    to: "\u5230",
    sample: "\u521d\u7248",
    
  },
  EN: { //英文翻译
    title: "	Basic Substance",
    type: "	Type",
    name: "	Chinese Name",
    enname:"English Name",
    aliasone: "Synonym",
    aliastwo: "	Synonym 2",
    aliasthree: "	Synonym 3",
    cascode: "	CAS No.",
    euIndex: "	EU-Index",
    einecs: "EC-Index",
    gadsl: "	GADSL",
    confidential: "	Confidential",
    reachSvhc: "REACH-SVHC",
    rate: "	Proportion",
    yes: "	Yes",
    no: "	No",
    surplus: "	Rest",
    fixed: "	Fixed",
    from: "	From",
    to: "	To",
    sample: "Sample",
  }
}
export default info //需要暴露出去
